/**
 * Maps a tax message key (from `getTotalInfoMessage` / `getTaxMessage` in
 * `@/lib/tax`) to its `price.*` i18n translation key. Shared by TaxInfoText
 * (checkout total), ProductInfo (PDP price badge), and PriceModal so all render
 * the same country-driven tax copy from a single source of truth. Kept in a
 * styleless module so consumers can reuse the mapping without importing
 * TaxInfoText's stylesheet.
 */
export const MESSAGE_KEY_MAP: Record<string, string> = {
  consumptionIncluded: 'consumption.included',
  vatIncluded: 'vat.included',
  gstIncluded: 'gst.included',
  salesTaxIncluded: 'tax.included',
  salesTaxExcluded: 'tax.excluded',
};

/** Long-form tax phrasing for price disclaimers (e.g. "exclusive of sales tax"). */
export const DETAIL_KEY_MAP: Record<string, string> = {
  consumptionIncluded: 'detail.consumption.included',
  vatIncluded: 'detail.vat.included',
  gstIncluded: 'detail.gst.included',
  salesTaxIncluded: 'detail.tax.included',
  salesTaxExcluded: 'detail.tax.excluded',
};

export const TAX_TRANSLATION_KEYS: Record<string, { short: string; detail: string }> = {
  consumptionIncluded: {
    short: MESSAGE_KEY_MAP.consumptionIncluded,
    detail: DETAIL_KEY_MAP.consumptionIncluded,
  },
  vatIncluded: { short: MESSAGE_KEY_MAP.vatIncluded, detail: DETAIL_KEY_MAP.vatIncluded },
  gstIncluded: { short: MESSAGE_KEY_MAP.gstIncluded, detail: DETAIL_KEY_MAP.gstIncluded },
  salesTaxIncluded: {
    short: MESSAGE_KEY_MAP.salesTaxIncluded,
    detail: DETAIL_KEY_MAP.salesTaxIncluded,
  },
  salesTaxExcluded: {
    short: MESSAGE_KEY_MAP.salesTaxExcluded,
    detail: DETAIL_KEY_MAP.salesTaxExcluded,
  },
};
